<p-tabView>
    <p-tabPanel header="Sent (Tagged)">
        <div class="grid">
            <div class="col-12">
                <p-toolbar styleClass="mb-4">
                    <ng-template pTemplate="left">
                        <div class="p-fluid">
                            <div class="p-formgrid">
                                <div class="row">
                                    <div class=" field ml-3">
                                        <p-dropdown appendTo="body" optionLabel="label" [(ngModel)]="selectedbatch"
                                            [options]="batchList" optionValue="value" [placeholder]="'Select Month/Date'"
                                            (ngModelChange)="handleDateType($event)">
                                        </p-dropdown>
                                    </div>
                                    <div class=" field ml-3" *ngIf="this.selectedbatch == 'Daily'">
                                        <input pInputText id="email2" class="textInp" [(ngModel)]="todaysDate"
                                            (ngModelChange)="handleDateChange($event)" dateFormat="mm-dd-yy" placeholder="Date"
                                            type="date" />
                                    </div>
                                    <div class=" field ml-3" *ngIf="this.selectedbatch == 'Monthly'">
                                        <p-calendar [(ngModel)]="monthDate" view="month" dateFormat="MM,yy" appendTo="body" [style]="{width: '10vw'}"
                                            (ngModelChange)="showMonthlyData($event)" [readonlyInput]="true"></p-calendar>
                                    </div>
                                    <div class=" field ml-3" style="width: 308px;" *ngIf="this.selectedbatch == 'Weekly'">
                                        <p-calendar dateFormat="mm-dd-yy" [(ngModel)]="selectedDates" placeholder="Select Week" appendTo="body" [style]="{width: '15vw'}"
                                            (onSelect)="selectWeek($event)" selectionMode="range" [readonlyInput]="true">
                                        </p-calendar>
                                    </div>
                                    <div class="field ml-3">
                                        <div class="input-with-icon">
                                            <!-- <span class="resetIcon" (click)="onReset()">
                                                <i class="pi pi-replay pointer" title="Reset"></i>
                                            </span> -->
                                            <button type="button" pButton pRipple (click)="onReset()" label="Clear" 
                                            class="p-button-secondary p-button-sm mt-1"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-toolbar>
            </div>
        </div>
        <ng-template pTemplate="content">
            <div *ngIf="isLoading" class="spinner-container">
                <p-progressSpinner *ngIf="isLoading" [style]="{ width: '45px', height: '37px' }" styleClass="custom-spinner"
                    strokeWidth="8" fill="var(--surface-ground)" animationDuration=".8s"></p-progressSpinner>
            </div>
            <p-dataView *ngIf="!isLoading" [value]="sentDocumentList" selectionMode="multiple" [paginator]="true" [rows]="12"
                filterBy="title" [sortField]="sortField" [sortOrder]="-1" layout="grid">
                <ng-template let-document let-index="rowIndex" pTemplate="gridItem">
                    <div class="col-12 md:col-2 dataView">
                        <div class="p-3">
                            <div class="grid formgrid">
                                <div class="col-12 md:col-2">
                                    <div class="field-checkbox gap-1">
                                        <p-checkbox [binary]="true" [(ngModel)]="document.selected" (onChange)="
                                            toggleSelection(document, index);
                                            checkboxChanged()
                                        " class="custom-margin"></p-checkbox>
                                        &nbsp;
                                        <div
                                            class="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-2 gap-3">
                                            <div class="flex align-items-center">
                                                <img [src]="'data:image/png;base64,' + document.imageTag" width="80" height="80"
                                                    alt="profile" style="max-height: 80px; max-height: 80px;"
                                                    class="border-square border-2 border-primary flex-shrink-0" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <!-- <ng-template pTemplate="footer">
                    <button pButton pRipple type="button" icon="pi pi-check" label="Continue" style="float: right;"
                        (click)="selectedImages()" class="p-button-raised"></button>
                </ng-template> -->

            </p-dataView>
            <div class="grid grid-nogutter justify-content-end mt-2">
                <p-button
                    label="Continue"
                    (click)="selectedImages()"
                    icon="pi pi-angle-right"
                    iconPos="right"
                    class="p-button-secondary"
                ></p-button>
            </div>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Unsent">
        <div class="grid">
            <div class="col-12">
                <p-toolbar styleClass="mb-4">
                    <ng-template pTemplate="left">
                        <div class="p-fluid">
                            <div class="p-formgrid">
                                <div class="row">
                                    <div class=" field ml-3">
                                        <p-dropdown appendTo="body" optionLabel="label" [(ngModel)]="selectedbatch2"
                                            [options]="batchList" optionValue="value" [placeholder]="'Select Month/Date'"
                                            (ngModelChange)="handleDateType2($event)">
                                        </p-dropdown>
                                    </div>
                                    <div class=" field ml-3" *ngIf="this.selectedbatch2 == 'Daily'">
                                        <input pInputText id="email2" class="textInp" [(ngModel)]="todaysDate2"
                                            (ngModelChange)="handleDateChange2($event)" dateFormat="mm-dd-yy" placeholder="Date"
                                            type="date" />
                                    </div>
                                    <div class=" field ml-3" *ngIf="this.selectedbatch2 == 'Monthly'">
                                        <p-calendar [(ngModel)]="monthDate2" view="month" dateFormat="MM,yy" appendTo="body" [style]="{width: '10vw'}"
                                            (ngModelChange)="showMonthlyData2($event)" [readonlyInput]="true"></p-calendar>
                                    </div>
                                    <div class=" field ml-3" style="width: 308px;" *ngIf="this.selectedbatch2 == 'Weekly'">
                                        <p-calendar dateFormat="mm-dd-yy" [(ngModel)]="selectedDates2" placeholder="Select Week" appendTo="body" [style]="{width: '15vw'}"
                                            (onSelect)="selectWeek2($event)" selectionMode="range" [readonlyInput]="true">
                                        </p-calendar>
                                    </div>
                                    <div class="field ml-3">
                                        <div class="input-with-icon">
                                            <!-- <span class="resetIcon" (click)="onReset2()">
                                                <i class="pi pi-replay pointer" title="Reset"></i>
                                            </span> -->
                                            <button type="button" pButton pRipple (click)="onReset2()" label="Clear" 
                                            class="p-button-secondary p-button-sm mt-1"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-toolbar>
            </div>
        </div>
        <ng-template pTemplate="content">
            <div *ngIf="isLoading2" class="spinner-container">
                <p-progressSpinner *ngIf="isLoading" [style]="{ width: '45px', height: '37px' }" styleClass="custom-spinner"
                    strokeWidth="8" fill="var(--surface-ground)" animationDuration=".8s"></p-progressSpinner>
            </div>
            <p-dataView *ngIf="!isLoading2" [value]="unSentDocumentList" selectionMode="multiple" [paginator]="true" [rows]="9"
                filterBy="title" [sortField]="sortField" [sortOrder]="-1" layout="grid">
                <ng-template let-document let-index="rowIndex" pTemplate="gridItem">
                    <div class="col-12 md:col-2 dataView">
                        <div class="p-3">
                            <div class="grid formgrid">
                                <div class="col-12 md:col-2">
                                    <div class="field-checkbox gap-1">
                                        <p-checkbox [binary]="true" [(ngModel)]="document.selected" (onChange)="
                                        toggleSelection(document, index);
                                        checkboxChanged()
                                    " class="custom-margin"></p-checkbox>
                                        &nbsp;
                                        <div
                                            class="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-2 gap-3">
                                            <div class="flex align-items-center">
                                                <img [src]="'data:image/png;base64,' + document.imageTag" width="80" height="80"
                                                    alt="profile" style="max-height: 80px; max-height: 80px;"
                                                    class="border-square border-2 border-primary flex-shrink-0" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <!-- <ng-template  class="footer-container">
                    <button pButton pRipple type="button" icon="pi pi-check" label="Continue" style="float: right;"
                        class="p-button-raised" (click)="selectedImages()"></button>
                </ng-template> -->

            </p-dataView>
            <div class="grid grid-nogutter justify-content-end mt-2">
                <p-button
                    label="Continue"
                    (click)="selectedImages()"
                    icon="pi pi-angle-right"
                    iconPos="right"
                    class="p-button-secondary"
                ></p-button>
            </div>

        </ng-template>

    </p-tabPanel>
</p-tabView>
